import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import { LEGAL } from './legalConfig';
import Logo from '../components/Logo';
import './legal.css';

// Shared layout for the Privacy Policy and Terms of Service: a contents list
// beside the document on wide screens, the document alone on narrow ones.
// sections: [{ id, title, body }]
const LegalPage = ({ title, current, summary, sections }) => {
    useEffect(() => {
        document.title = `${title} · ${LEGAL.product}`;
        // Links like /privacy#cookies land on their section
        const target = window.location.hash && document.getElementById(window.location.hash.slice(1));
        if (target) target.scrollIntoView();
        else window.scrollTo(0, 0);
    }, [title]);

    return (
        <div className="lg-page">
            <header className="lg-bar">
                <div className="lg-bar-inner">
                    <Link to="/" className="lg-brand" aria-label={`${LEGAL.product} home`}>
                        <Logo size={30} textSize={18} />
                    </Link>
                    <nav className="lg-bar-links" aria-label="Legal">
                        <Link to="/privacy" aria-current={current === 'privacy' ? 'page' : undefined}>Privacy</Link>
                        <Link to="/terms" aria-current={current === 'terms' ? 'page' : undefined}>Terms</Link>
                    </nav>
                </div>
            </header>

            <div className="lg-layout">
                <nav className="lg-toc" aria-label="Contents">
                    <div className="lg-toc-title">Contents</div>
                    <ol>
                        {sections.map((section, index) => (
                            <li key={section.id}><a href={`#${section.id}`}>{index + 1}. {section.title}</a></li>
                        ))}
                    </ol>
                </nav>

                <main className="lg-doc">
                    <h1>{title}</h1>
                    <div className="lg-updated">Effective {LEGAL.effectiveDate}</div>
                    {summary && (
                        <div className="lg-summary">
                            <h2>The short version</h2>
                            {summary}
                        </div>
                    )}
                    {sections.map((section, index) => (
                        <section key={section.id} id={section.id}>
                            <h2>{index + 1}. {section.title}</h2>
                            {section.body}
                        </section>
                    ))}
                </main>
            </div>

            <footer className="lg-footer">
                © {new Date().getFullYear()} {LEGAL.company}
                <Link to="/privacy">Privacy Policy</Link>
                <Link to="/terms">Terms of Service</Link>
                <a href={`mailto:${LEGAL.email}`}>{LEGAL.email}</a>
            </footer>
        </div>
    );
};

export default LegalPage;
